import "./App.css";
import fullLogo from "./images/logo_bandeau.png";
import circleBackground from "./images/circleBackGround.svg";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import Home from "./pages/Home";
import DeleteAccount from "./pages/DeleteAccount";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CoachMode from "./pages/CoachMode";
import ProUpgrade from "./pages/ProUpgrade";
import React, { useState, useEffect } from "react";
import { isLoggedIn, getUser, logout, getCurrentSubscription } from "./services/authService";

function Header() {
	const navigate = useNavigate();
	const [user, setUser] = useState(null);
	const [loggedIn, setLoggedIn] = useState(false);
	const [isProUser, setIsProUser] = useState(false);

	useEffect(() => {
		let subscriptionChecked = false;

		const checkAuth = () => {
			const logged = isLoggedIn();
			setLoggedIn(logged);
			if (logged) {
				setUser(getUser());
				// Check subscription once when login is detected
				if (!subscriptionChecked) {
					subscriptionChecked = true;
					checkSubscription();
				}
			} else {
				setUser(null);
				setIsProUser(false);
				subscriptionChecked = false;
			}
		};

		const checkSubscription = async () => {
			if (isLoggedIn()) {
				const result = await getCurrentSubscription();
				if (result.success && result.subscription) {
					const proTierIds = [4, 6];
					setIsProUser(proTierIds.includes(result.subscription.idAbonnementType));
				} else {
					setIsProUser(false);
				}
			}
		};

		checkAuth();
		// Re-check on storage change (login/logout in other tabs)
		window.addEventListener("storage", checkAuth);
		// Re-check periodically for same-tab updates
		const interval = setInterval(checkAuth, 1000);

		return () => {
			window.removeEventListener("storage", checkAuth);
			clearInterval(interval);
		};
	}, []);

	const handleLogout = () => {
		logout();
		setLoggedIn(false);
		setUser(null);
		navigate("/");
	};

	return (
		<header>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Link to="/">
					<img src={fullLogo} alt="Gymnote Logo" className="logo-image" />
				</Link>
				{loggedIn && user ? (
					<div className="header-user-section">
						<Link to={isProUser ? "/coach" : "/pro"} className="header-dashboard-link">
							Dashboard Web {!isProUser && <span style={{ marginLeft: "4px" }}>👑</span>}
						</Link>
						<Link to="/dashboard" className="header-user-name" title="Mon compte">
							{user.prenom} {user.nom}
						</Link>
						<button onClick={handleLogout} className="header-logout-btn">
							Deconnexion
						</button>
					</div>
				) : (
					<Link to="/login" className="header-login-link">
						Connexion
					</Link>
				)}
			</div>
		</header>
	);
}

function App() {
	return (
		<Router>
			<div className="container" style={{ backgroundImage: `url(${circleBackground})`, backgroundSize: '100% auto', backgroundPosition: 'top center', backgroundRepeat: 'no-repeat' }}>
				<Header />
				<main>
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/delete-account" element={<DeleteAccount />} />
						<Route path="/login" element={<Login />} />
						<Route path="/dashboard" element={<Dashboard />} />
						<Route path="/coach" element={<CoachMode />} />
						<Route path="/pro" element={<ProUpgrade />} />
					</Routes>
				</main>
				<footer>
					<p>Copyright 2025 Gymnote</p>
					<Link to="/delete-account" className="footer-link">Supprimer mon compte</Link>
				</footer>
			</div>
		</Router>
	);
}

export default App;
